module.exports = __webpack_public_path__ + "e1fa7017d8f3f206ded055b1ff5221fb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/helmet-astronaut-s.png
// module id = 2922
// module chunks = 0